import { DeviceGroup, GroupConflictError } from "luxedo-data"
import { asyncConfirmOverlay } from "overlay"
import { Toast } from "toaster"

export async function reactivateGroup(device: DeviceGroup) {
	let conflictingGroups: DeviceGroup[] = []

	// Try to activate the group
	try {
		await device.activate()
	} catch (e) {
		// If it fails with a group conflict, get the list of conflicting groups so we can resolve it
		if (e instanceof GroupConflictError) {
			if (!e.resolvable) {
				Toast.error("This group shares devices with an active group which you do not own.")
				return
			}

			conflictingGroups = e.conflictingGroups
			console.warn({ conflictingGroups })
		} else {
			throw e
		}
	}

	// Resolve the group conflict if there are any
	if (conflictingGroups.length > 0) {
		try {
			await asyncConfirmOverlay({
				title: "Group Conflict",
				prompt: [
					`One or more devices in this group are shared by another active group.\n`,
					`By continuing, the following groups will be deactivated:`,
					conflictingGroups.map((group) => `<b>${group.name}</b>`).join("\n"),
					"Are you sure you want to continue?",
				],
				confirmText: "Continue",
				denyText: "Cancel",
			})
		} catch (e) {
			return
		}

		// Deactivate the conflicting groups
		for (let group of conflictingGroups) {
			await group.deactivate()
		}

		await device.activate()
	}
}
